import { all, fork } from 'redux-saga/effects';
import { listUsageSaga } from './list-usage';
export function* rootSaga() {
    yield all([fork(listUsageSaga)]);
}
